import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { isNullOrUndefined, isValidCSV } from '../../../../../utils/functionsUtils';
import { MimeTypesEnum } from "../../../../../utils/enumsUtil";
import { useWMSLockMassiveDispatch } from "../../../../../hooks/WMSLockMassiveDispatch";

const WMSMassiveDispatchModal = ({
    show,
    handleClose,
    requestingBulkUploadOrdersWMS,
    bulkUploadOrdersWMSRequest
}) => {
    const { isLocked, lock, unlock } = useWMSLockMassiveDispatch();

    const {
        handleSubmit: uploadModalSumbit,
        control: uploadModalControl,
        formState: { errors: uploadModalErrors },
        watch,
        setValue,
        reset,
        clearErrors
    } = useForm({
        defaultValues: {
            fileWithOrders: null,
        }
    });

    const resetFileSelection = () => {
        setValue('fileWithOrders', '');
        clearErrors('fileWithOrders');
    };

    const changeFile = (event) => {
        const file = event.target.files[0];
        setValue('fileWithOrders', file);
        clearErrors('fileWithOrders');
    };

    const renderHelpTooltip = (title) => (
        <Tooltip id="button-tooltip">
            <h6>El Excel debe tener formato CSV y no debe tener encabezados.</h6>
        </Tooltip>
    );

    const uploadMassivePreparation = (data) => {
        Swal.fire({
            html: `
            <b>¿Está seguro de actualizar el estado de estas órdenes?</b>
            <br />
            <br />
            <h6>El proceso puede tardar, por lo que se realizará en segundo plano.</h6>
            `,
            icon: 'question',
            showConfirmButton: true,
            confirmButtonText: "OK",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
        }).then(result => {
            handleClose();
            reset();

            if (!result.isConfirmed) return;
            lock();

            const reader = new FileReader();
            reader.readAsText(data.fileWithOrders);
            reader.onload = () => {
                if (!isValidCSV(reader.result, 1, 1)) {
                    resetFileSelection();
                    unlock();
                    return;
                }
                bulkUploadOrdersWMSRequest(data.fileWithOrders);
            };
            reader.onerror = () => {
                resetFileSelection();
                unlock();
            };
        });
    };

    const fileWatcher = watch('fileWithOrders', null);

    useEffect(() => {
        reset();
    }, []);

    return (
        <Modal
            show={show}
            onHide={() => { handleClose(); resetFileSelection(); }}
            onEscapeKeyDown={() => { handleClose(); resetFileSelection(); }}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <form onSubmit={uploadModalSumbit(uploadMassivePreparation)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="mx-2">
                                <OverlayTrigger
                                    placement='bottom'
                                    overlay={renderHelpTooltip("Formato de Cargue")}
                                >
                                    <i className="fas fa-info-circle fa-sm"></i>
                                </OverlayTrigger>
                            </div>
                            <div>Cargar Archivo de Ordenes a Despachar</div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label htmlFor="fileWithOrders" className="form-label">
                                Archivo *
                            </label>
                            <Controller
                                control={uploadModalControl}
                                name="fileWithOrders"
                                rules={{
                                    required: {
                                        value: true,
                                        message: 'Debe seleccionar un archivo'
                                    },
                                    validate: (value) => {
                                        return !isNullOrUndefined(MimeTypesEnum.CSV.find(e => e === value.type)) || "El archivo debe ser formato CSV";
                                    },
                                }}
                                render={({ field }) => (
                                    <div className="custom-file">
                                        <input
                                            type='file'
                                            accept=".csv"
                                            onChange={(e) => changeFile(e)}
                                            onClick={(e) => e.target.value = null}
                                            className={`custom-file-input ${uploadModalErrors.fileWithOrders && 'is-invalid'}`}
                                        />
                                        <label
                                            className='custom-file-label'
                                            htmlFor='validatedCustomFile'
                                            onClick={() => document.getElementById('validatedCustomFile').click()}
                                        >
                                            {fileWatcher ? fileWatcher.name : 'Seleccionar archivo...'}
                                        </label>
                                        {uploadModalErrors.fileWithOrders &&
                                            <span className="error-message">{uploadModalErrors.fileWithOrders.message}</span>
                                        }
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { handleClose(); resetFileSelection(); }}>
                        Cancelar
                    </Button>
                    <Button variant="primary" type="submit" disabled={isLocked}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    requestingBulkUploadOrdersWMS: state.warehouseState.requestingBulkUploadOrdersWMS,
});

const mapDispatchToProps = (dispatch) => ({
    bulkUploadOrdersWMSRequest: (payload) =>
        dispatch({
            type: "BULK_UPLOAD_ORDERS_WMS_REQUEST",
            value: payload,
        }),
});

export default connect(mapStateToProps, mapDispatchToProps)(WMSMassiveDispatchModal);
